import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Login } from './Login';
import { LoginCallback } from './LoginCallback';
import { Logout } from './Logout';
import { HomePage } from './Home';
import { NotFoundPage } from './NotFound';
import { PackagesPage } from './Packages';
import { ListPackagesPage } from './Packages/List';
import { PostPackagePage } from './Packages/Post';
import { ViewPackagePage } from './Packages/View';
import { Account, hasMissingAccountInformation } from './Account';
import { getUrlToPostPackagePage, getUrlToPackagesPage, getUrlToListPackagesPage, getUrlToViewPackagePage, getUrlToLoginPage, getUrlToLogoutPage, getUrlToLoginCallbackPage, getUrlToAccountPage } from './urls';
import { useIsAuthenticated } from 'utils/auth';
import { useAuthenticatedUserData } from "contexts/user-authentication";

export function Pages() {
  return (
    <>
      <RedirectToAccountIfNotFilled />
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path={getUrlToLoginPage()} element={<Login />} />
        <Route path={getUrlToLoginCallbackPage()} element={<LoginCallback />} />
        <Route path={getUrlToLogoutPage()} element={<Logout />} />
        <Route path={getUrlToPackagesPage()} element={<EnsureAuthenticated><PackagesPage /></EnsureAuthenticated>}>
          <Route path={getUrlToListPackagesPage()} element={<ListPackagesPage />} />
          <Route path={getUrlToPostPackagePage()} element={<PostPackagePage />} />
          <Route path={getUrlToViewPackagePage()} element={<ViewPackagePage />} />
        </Route>
        <Route path={getUrlToAccountPage()} element={<EnsureAuthenticated><Account /></EnsureAuthenticated>} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

function EnsureAuthenticated ({ children }) {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return (<Navigate to={getUrlToLoginPage()} />);
  }

  return children;
}

function RedirectToAccountIfNotFilled () {
  const { pathname } = useLocation();
  const { user, isAuthenticated } = useAuthenticatedUserData();
  if (pathname === getUrlToAccountPage() || pathname === getUrlToLogoutPage() || !isAuthenticated || !user) return null;
  const { userDetails } = user;
  if (!hasMissingAccountInformation(userDetails)) return null;
  return <Navigate to={getUrlToAccountPage(pathname)} />;
}
